var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "hero is-fullheight" }, [
    _c("div", { staticClass: "hero-body" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "columns is-mobile is-centered" }, [
          _c("div", { staticClass: "column column is-half is-narrow" }, [
            _c(
              "h1",
              { staticClass: "title is-1" },
              [
                _vm._v(" 404 "),
                _c("b-icon", {
                  attrs: { icon: "exclamation", size: "is-small" },
                }),
              ],
              1
            ),
            _c("h2", { staticClass: "subtitle is-3" }, [
              _vm._v(" Not found... "),
            ]),
            _c(
              "div",
              { staticClass: "content" },
              [
                _c("p", [
                  _vm._v(
                    "The site configured at this address does not contain the requested file. "
                  ),
                  _c("code", [_vm._v(_vm._s(_vm.$route.path))]),
                  _vm._v("."),
                ]),
                _vm._m(0),
                [_vm._v(_vm._s(_vm.now))],
              ],
              2
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v(
        "You may have typed the address incorrectly or you may have used an outdated link."
      ),
      _c("br"),
      _vm._v(" "),
      _c("b", [_vm._v("You will be redirected to the main page.")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }